import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ArrowRight, Zap } from 'lucide-react';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <section className="relative pt-20 pb-24 md:pt-32 md:pb-32 overflow-hidden" data-id="element-74">
      {/* Background Glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-brand-orange/10 blur-[120px] rounded-full pointer-events-none" data-id="element-75" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-76">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-77">
          {/* Text Content */}
          <div className="order-2 lg:order-1" data-id="element-78">
            <FadeIn data-id="element-79">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-orange/10 border border-brand-orange/20 text-brand-orange text-sm font-semibold mb-6" data-id="element-80">
                <Zap size={16} className="fill-brand-orange" data-id="element-81" />
                <span data-id="element-82">Sistema Probado de 10 Minutos</span>
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6" data-id="element-83">
                El Ritual de 10 Minutos: Detén la Procrastinación y{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-orange to-orange-300" data-id="element-84">
                  Recupera tu Productividad
                </span>{' '}
                Hoy
              </h1>
              <p className="text-xl md:text-2xl text-gray-300 font-medium mb-8 leading-relaxed" data-id="element-85">
                La guía exacta para emprendedores que saben qué hacer, pero no
                logran dar el primer paso (sin depender de la fuerza de
                voluntad).
              </p>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-86">
              <div className="space-y-6 text-gray-400 text-lg leading-relaxed mb-10 border-l-2 border-brand-orange/30 pl-6" data-id="element-87">
                <p data-id="element-88">
                  Estás frente a la pantalla. Tienes el café listo, la lista de
                  tareas escrita y toda la intención de avanzar. Pero pasan las
                  horas y lo único que has hecho es revisar correos
                  irrelevantes, ordenar archivos que no importan o perderte en
                  redes sociales.
                </p>
                <p data-id="element-89">
                  Sientes ese peso en el pecho. Sabes que cada minuto perdido es
                  dinero que no entra y un paso atrás en tus metas. No eres
                  perezoso; simplemente estás atrapado en el muro de la inercia,
                  y tu cerebro te está mintiendo para mantenerte ahí.
                </p>
              </div>

              <Button onClick={scrollToOffer} className="w-full sm:w-auto text-lg py-5 px-10" data-id="element-90">
                DESCARGAR RITUAL AHORA
                <ArrowRight size={20} data-id="element-91" />
              </Button>
              <p className="mt-4 text-sm text-gray-500 flex items-center gap-2" data-id="element-92">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-93"></span>
                Acceso instantáneo. Empieza en 2 minutos.
              </p>
            </FadeIn>
          </div>

          {/* Image Mockup */}
          <div className="order-1 lg:order-2 flex justify-center lg:justify-end relative" data-id="element-94">
            <FadeIn direction="left" delay={0.3} data-id="element-95">
              <div className="relative" data-id="element-96">
                <div className="absolute inset-0 bg-brand-orange/20 blur-[60px] rounded-full transform scale-90" data-id="element-97" />
                <img src="https://cdn.magicpatterns.com/uploads/pqLBGKDBxrGBBtccfMGi9A/El_Ritual_Anti-Procrastinacion_de_10_minutos-Mockup_A.png" alt="El Ritual Anti-Procrastinación de 10 Minutos Mockup" className="relative z-10 w-full max-w-[500px] object-contain drop-shadow-2xl transform hover:scale-[1.02] transition-transform duration-500" data-id="element-98" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}